export default __webpack_public_path__ + "static/media/Logoblanco.c459e8b0.png";